import React, { useEffect, useState } from 'react';
import { Modal, ModalBody, Spinner } from 'reactstrap';
import { startExpiryWatcher, getTokenExpiry, performLogout } from '../utils/auth';

const AuthWatcher = () => {
  const [expired, setExpired] = useState(false);

  // Kick‑off / refresh watcher on mount
  useEffect(() => {
    startExpiryWatcher();
  }, []);

  // Poll every 30 s (cheap) – catches clock skew
  useEffect(() => {
    const id = setInterval(() => {
      const exp = getTokenExpiry();
      if (exp && Date.now() >= exp * 1000) {
        setExpired(true);
        performLogout();
      }
    }, 30_000);
    return () => clearInterval(id);
  }, []);

  return (
    <Modal centered isOpen={expired} backdrop="static">
      <ModalBody className="d-flex flex-column align-items-center">
        <Spinner style={{ width: '3rem', height: '3rem' }} />
        <p className="mt-3 mb-0 fw-semibold text-center">
          Your session has expired.<br />Redirecting to login…
        </p>
      </ModalBody>
    </Modal>
  );
};

export default AuthWatcher;
